import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() => ({
    accountHeader: {
        fontSize: '28px',
        fontWeight: 600,
        lineHeight: '36px',
        margin: '20px 0',
    },
    recentTransactions: {
        marginTop: 35,
        '& .drop-down-title': {
            fontSize: 20,
        },
    },
}))
